import axios from 'axios';

import firebase from './firebase';

const LOCAL_SERVER_ONLINE = process.env.REACT_APP_API_TARGET === 'local';

const DEVELOPMENT = !document.location.host.includes('gastronaut.ai') && process.env.REACT_APP_API_TARGET !== 'api' // && false;


// Deployed hosts all match the gastronaut.ai host check above, so without this
// override every non-prod deploy (e.g. staging.app.gastronaut.ai) would talk to
// the prod API.
const API_URL_OVERRIDE = (process.env.REACT_APP_API_URL || '').trim().replace(/\/+$/, '');

const liveServer = API_URL_OVERRIDE || 'https://api.gastronaut.ai';

const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID || 'schillingroofbarhd';

const devServer = LOCAL_SERVER_ONLINE
  ? 'http://localhost:8000'
  : API_URL_OVERRIDE || (process.env.REACT_APP_API_TARGET === 'beta'
    ? 'https://beta.api.gastronaut.ai'
    : 'https://dev.api.gastronaut.ai');

let authReady = null;

// firebase restores the session asynchronously, currentUser stays null until then
const waitForAuth = () => {
  if (!authReady) {
    authReady = new Promise((resolve) => {
      let unsubscribe = null;

      unsubscribe = firebase.auth().onAuthStateChanged(() => {
        resolve();
        if (unsubscribe) unsubscribe();
      });
    });
  }

  return authReady;
};

const currentIdToken = async () => {
  await waitForAuth();

  const user = firebase.auth().currentUser;

  return user ? user.getIdToken() : null;
};

// Some v03 routes identify staff by a verified Firebase ID token instead of the
// uid in the body, so send it on every call to our own API.
export const withIdToken = (instance) => {
  instance.interceptors.request.use(async (config) => {
    // voucher and support calls bring their own Authorization, never overwrite it
    const hasAuth =
      config.headers.Authorization ||
      config.headers.authorization ||
      config.headers.common?.Authorization;

    if (hasAuth) return config;

    try {
      // the axios timeout starts after the interceptor, so cap the token wait here
      const token = await Promise.race([
        currentIdToken(),
        new Promise((resolve) => setTimeout(() => resolve(null), 5000)),
      ]);

      if (token) config.headers.Authorization = `Bearer ${token}`;
    } catch (e) {
      console.error('ID token unavailable, sending request without it', e?.code);
    }

    return config;
  });

  return instance;
};

export default withIdToken(
  axios.create({
    baseURL: DEVELOPMENT
      ? devServer // 'https://europe-west3-schillingroofbarhd.cloudfunctions.net/apiEndpoint'
      : liveServer,
    timeout: 60000,
    headers: { 'X-Custom-Header': 'dashboard', uid: window.uid || '' },
  }),
);

export const apiendpoint = withIdToken(
  axios.create({
    baseURL: `https://europe-west3-${projectId}.cloudfunctions.net/apiEndpoint`,
    timeout: 60000,
    headers: { 'X-Custom-Header': 'dashboard', uid: window.uid || '' },
  }),
);

export const googleServer = withIdToken(
  axios.create({
    baseURL: `https://europe-west3-${projectId}.cloudfunctions.net/apiEndpoint`,
    timeout: 60000,
    headers: { 'X-Custom-Header': 'dashboard', uid: window.uid || '' },
  }),
);

export const mainServer = withIdToken(
  axios.create({
    baseURL: DEVELOPMENT
      ? devServer
      : liveServer,
    timeout: 60000,
    headers: { 'X-Custom-Header': 'dashboard', uid: window.uid || '' },
  }),
);
